import { apiCall } from "../api";
import OrganizationSettingsDto from "../../DTOs/Organization/OrganizationSettingsDto";

export const updateSettings = async (dto) => {
  const url = 'organization/updateOrganizationSettings';
  let response = await apiCall(url, { method: 'POST', body: dto });
  return new OrganizationSettingsDto(response.result);
}
